import { useEffect, useRef, useState } from 'react';
import { ProductVariantColorViewModel, ProductVariantWeightViewModel } from '@/types/api';
import { cn } from '@/utils/cn';
import ColorVariants from './color-variants';
import WeightVariants from './weight-variants';
import { VariantContextType } from '../../context/types';
import { useVariantContextValues } from '../../context/use-variant-context-values';
interface Props {
  isCarousel?: boolean;
  className?: string;
  contextType: VariantContextType;
}
const VariantsContainer = ({
  className,
  isCarousel = false,
  contextType
}: Props) => {
  const [selectedColor, setSelectedColor] = useState<ProductVariantColorViewModel>();
  const [selectedWeight, setSelectedWeight] = useState<ProductVariantWeightViewModel>();
  const isUserManuallySelectedVariant = useRef(false);
  const {
    selectVariant,
    selectedVariant,
    hasColorOptions,
    hasWeightOptions
  } = useVariantContextValues(contextType);
  useEffect(() => {
    if (!isUserManuallySelectedVariant.current) return;
    const selectedColorId = selectedColor?.id;
    const selectedWeightValue = selectedWeight?.value;
    if (hasColorOptions && hasWeightOptions) {
      if (selectedColorId && selectedWeightValue) selectVariant(selectedColorId, selectedWeightValue);
      if (!selectedColorId || !selectedWeightValue) selectVariant(null, null);
    }
    if (hasColorOptions && !hasWeightOptions) {
      selectVariant(selectedColorId || null, null);
    }
    if (!hasColorOptions && hasWeightOptions) {
      selectVariant(null, selectedWeightValue || null);
    }
  }, [hasColorOptions, hasWeightOptions, selectVariant, selectedColor?.id, selectedWeight?.value]);
  useEffect(() => {
    if (isUserManuallySelectedVariant.current) return;
    const defaultColor = selectedVariant?.color;
    const defaultWeight = selectedVariant?.weight;
    if (defaultColor) {
      setSelectedColor(defaultColor);
    }
    if (defaultWeight) {
      setSelectedWeight(defaultWeight);
    }
  }, [selectedVariant]);
  const colorSelectHandler = (color: ProductVariantColorViewModel) => {
    isUserManuallySelectedVariant.current = true;
    if (selectedColor?.id === color.id) {
      setSelectedColor(undefined);
      return;
    }
    setSelectedColor(color);
  };
  const weightSelectHandler = (weight: ProductVariantWeightViewModel) => {
    isUserManuallySelectedVariant.current = true;
    if (selectedWeight?.value === weight.value) {
      setSelectedWeight(undefined);
      return;
    }
    setSelectedWeight(weight);
  };
  return <div className={cn('flex w-full flex-col gap-1.5 lg:gap-3', className)} data-sentry-component="VariantsContainer" data-sentry-source-file="variants-container.tsx">
            <WeightVariants contextType={contextType} isCarousel={isCarousel} clickHandler={weightSelectHandler} selectedColor={selectedColor} selectedWeight={selectedWeight} data-sentry-element="WeightVariants" data-sentry-source-file="variants-container.tsx" />
            <ColorVariants contextType={contextType} isCarousel={isCarousel} clickHandler={colorSelectHandler} selectedColor={selectedColor} selectedWeight={selectedWeight} data-sentry-element="ColorVariants" data-sentry-source-file="variants-container.tsx" />
        </div>;
};
export default VariantsContainer;